import template from 'lodash/template';
import settings from "../data/endpoints";

const socketQuery = {
  getRetailQuery() {
    return template(settings.socket.channels[sevenConfig.data.dp.toLowerCase()])({
      token: sevenConfig.data.user.auth.token
    });
  },

  getTerminalQuery() {
    return template(settings.socket.channels[sevenConfig.data.dp.toLowerCase()])({
      token: sevenConfig.data.account.password,
      username: sevenConfig.data.device.uuid
    });
  },

  getWebQuery() {}
};

export default socketQuery;



// WEBPACK FOOTER //
// socketQuery.js